// **************************
// CONTACT TYPE
// **************************

import { REGISTRATION_STATE_APPROVED, REGISTRATION_STATE_SUSPENDED } from "../constants";

export const getContactTypeList = (language, registrationState) => {
    switch (language) {
        case 'pt':
            if(registrationState === REGISTRATION_STATE_APPROVED) {
                return SUPPORT_CONTACT_TYPES;
            }
            else if(registrationState === REGISTRATION_STATE_SUSPENDED) {
                return SUSPENDED_SUPPORT_CONTACT_TYPES;
            }
            else {
                return REGISTRATION_SUPPORT_CONTACT_TYPES;
            }
        break;
        case 'en': 
            if(registrationState === REGISTRATION_STATE_APPROVED) {
                return EN_SUPPORT_CONTACT_TYPES;
            }
            else if(registrationState === REGISTRATION_STATE_SUSPENDED) {
                return EN_SUSPENDED_SUPPORT_CONTACT_TYPES;
            }
            else {
                return EN_REGISTRATION_SUPPORT_CONTACT_TYPES;
            }
        break;
        case 'es':
            if(registrationState === REGISTRATION_STATE_APPROVED) {
                return ES_SUPPORT_CONTACT_TYPES;
            }
            else if(registrationState === REGISTRATION_STATE_SUSPENDED) {
                return ES_SUSPENDED_SUPPORT_CONTACT_TYPES;
            }
            else {
                return ES_REGISTRATION_SUPPORT_CONTACT_TYPES;
            }
        break;
        case 'fr':
            if(registrationState === REGISTRATION_STATE_APPROVED) {
                return FR_SUPPORT_CONTACT_TYPES;
            }
            else if(registrationState === REGISTRATION_STATE_SUSPENDED) {
                return FR_SUSPENDED_SUPPORT_CONTACT_TYPES;
            }
            else {
                return FR_REGISTRATION_SUPPORT_CONTACT_TYPES;
            }
        break;
        default:
            break;
    }
}

export const isSuspensionContactType = (contactType) => {
    if (contactType === null) return false;

    return contactType.code === SUSPENSION_REQUEST_OPTION.code || contactType.code === CANCELLATION_REQUEST_OPTION.code;
}

export const isCloseSuspensionContactType = (contactType) => {
    if (contactType === null) return false;

    return contactType.code === CLOSE_SUSPENSION_REQUEST_OPTION.code;
}

// PT VERSION

export const SUSPENSION_REQUEST_OPTION = { name: 'Pedido de suspensão de inscrição', code: 5 };
export const CLOSE_SUSPENSION_REQUEST_OPTION = { name: 'Pedido de levantamento de suspensão de inscrição', code: 6 };
export const CANCELLATION_REQUEST_OPTION = { name: 'Pedido de cancelamento de inscrição', code: 7 };

export const SUPPORT_CONTACT_TYPES = [
    { name: 'Denúncia de violação de dados (RGPD)', code: 4 },
    { name: 'Pedido de informação', code: 1 },
    { name: 'Pedido de remoção de dados pessoais', code: 3 },
    { name: 'Pedido de suporte', code: 2 },
    SUSPENSION_REQUEST_OPTION,
    CANCELLATION_REQUEST_OPTION
];

export const SUSPENDED_SUPPORT_CONTACT_TYPES = [
    { name: 'Pedido de informação', code: 1 },
    { name: 'Pedido de suporte', code: 2 },
    CLOSE_SUSPENSION_REQUEST_OPTION
];

export const REGISTRATION_SUPPORT_CONTACT_TYPES = [
    { name: 'Pedido de informação', code: 1 },
    { name: 'Pedido de suporte', code: 2 }
];

// EN VERSION

export const EN_SUSPENSION_REQUEST_OPTION = { name: 'Request for enrollment suspension', code: 5 };
export const EN_CLOSE_SUSPENSION_REQUEST_OPTION = { name: 'Enrollment suspension withdrawal request', code: 6 };
export const EN_CANCELLATION_REQUEST_OPTION = { name: 'Request for enrollment cancellation', code: 7 };

export const EN_SUPPORT_CONTACT_TYPES = [
    { name: 'Data Breach Reporting (GDPR)', code: 4 },
    { name: 'Information request', code: 1 },
    { name: 'Personal data removal request', code: 3 },
    { name: 'Support request', code: 2 },
    EN_SUSPENSION_REQUEST_OPTION,
    EN_CANCELLATION_REQUEST_OPTION
];

export const EN_SUSPENDED_SUPPORT_CONTACT_TYPES = [
    { name: 'Information request', code: 1 },
    { name: 'Support request', code: 2 },
    EN_CLOSE_SUSPENSION_REQUEST_OPTION
];

export const EN_REGISTRATION_SUPPORT_CONTACT_TYPES = [
    { name: 'Information request', code: 1 },
    { name: 'Support request', code: 2 }
];

// ES VERSION

export const ES_SUSPENSION_REQUEST_OPTION = { name: 'Solicitud de suspensión de la inscripción', code: 5 };
export const ES_CLOSE_SUSPENSION_REQUEST_OPTION = { name: 'Solicitud de retirada de suspensión de la inscripción', code: 6 };
export const ES_CANCELLATION_REQUEST_OPTION = { name: 'Solicitud de anulación de la inscripción', code: 7 };

export const ES_SUPPORT_CONTACT_TYPES = [
    { name: 'Informar de la violación de datos (RGPD)', code: 4 },
    { name: 'Solicitud de información', code: 1 },
    { name: 'Solicitud de eliminación de datos personales', code: 3 },
    { name: 'Solicitud de apoyo', code: 2 },
    ES_SUSPENSION_REQUEST_OPTION,
    ES_CANCELLATION_REQUEST_OPTION
];

export const ES_SUSPENDED_SUPPORT_CONTACT_TYPES = [
    { name: 'Solicitud de información', code: 1 },
    { name: 'Solicitud de apoyo', code: 2 },
    ES_CLOSE_SUSPENSION_REQUEST_OPTION
];

export const ES_REGISTRATION_SUPPORT_CONTACT_TYPES = [
    { name: 'Solicitud de información', code: 1 },
    { name: 'Solicitud de apoyo', code: 2 }
];

// FR VERSION

export const FR_SUSPENSION_REQUEST_OPTION = { name: "Demande de suspension d'inscription", code: 5 };
export const FR_CLOSE_SUSPENSION_REQUEST_OPTION = { name: "Demande de levée de suspension d'inscription", code: 6 };
export const FR_CANCELLATION_REQUEST_OPTION = { name: "Demande de annulation d'inscription", code: 7 };

export const FR_SUPPORT_CONTACT_TYPES = [
    { name: 'Plainte de violation de données (RGPD)', code: 4 },
    { name: "Demande d'information", code: 1 },
    { name: 'Demande de suppression de données personnelles', code: 3 },
    { name: 'Demande de support', code: 2 },
    FR_SUSPENSION_REQUEST_OPTION,
    FR_CANCELLATION_REQUEST_OPTION
];

export const FR_SUSPENDED_SUPPORT_CONTACT_TYPES = [
    { name: "Demande d'information", code: 1 },
    { name: 'Demande de support', code: 2 },
    FR_CLOSE_SUSPENSION_REQUEST_OPTION
];

export const FR_REGISTRATION_SUPPORT_CONTACT_TYPES = [
    { name: "Demande d'information", code: 1 },
    { name: 'Demande de support', code: 2 }
];

// **************************
// SUSPENSION TYPE
// **************************

export const getSuspensionTypeList = (language) => {
    switch (language) {
        case 'pt':
            return SUPPORT_SUSPENSION_TYPES;
        break;
        case 'en':
            return EN_SUPPORT_SUSPENSION_TYPES;
        break;
        case 'es':
            return ES_SUPPORT_SUSPENSION_TYPES;
        break;
        case 'fr':
            return FR_SUPPORT_SUSPENSION_TYPES;
        break;
        default:
            break;
    }
}

// PT Version

export const SUSPENSION_TYPE_SUSPENSION_OPTION = { name: 'Suspensão temporária', code: 1 };
export const SUSPENSION_TYPE_CANCEL_OPTION = { name: 'Cancelamento', code: 2 };

export const SUPPORT_SUSPENSION_TYPES = [
    SUSPENSION_TYPE_SUSPENSION_OPTION,
    SUSPENSION_TYPE_CANCEL_OPTION,
];

// EN Version

export const EN_SUSPENSION_TYPE_SUSPENSION_OPTION = { name: 'Temporary suspension', code: 1 };
export const EN_SUSPENSION_TYPE_CANCEL_OPTION = { name: 'Cancellation', code: 2 };

export const EN_SUPPORT_SUSPENSION_TYPES = [
    EN_SUSPENSION_TYPE_SUSPENSION_OPTION,
    EN_SUSPENSION_TYPE_CANCEL_OPTION,
];

// ES Version

export const ES_SUSPENSION_TYPE_SUSPENSION_OPTION = { name: 'Suspensión temporal', code: 1 };
export const ES_SUSPENSION_TYPE_CANCEL_OPTION = { name: 'Anulación', code: 2 };

export const ES_SUPPORT_SUSPENSION_TYPES = [
    ES_SUSPENSION_TYPE_SUSPENSION_OPTION,
    ES_SUSPENSION_TYPE_CANCEL_OPTION,
];

// FR Version

export const FR_SUSPENSION_TYPE_SUSPENSION_OPTION = { name: 'Suspension temporaire', code: 1 };
export const FR_SUSPENSION_TYPE_CANCEL_OPTION = { name: 'Annulation', code: 2 };

export const FR_SUPPORT_SUSPENSION_TYPES = [
    FR_SUSPENSION_TYPE_SUSPENSION_OPTION,
    FR_SUSPENSION_TYPE_CANCEL_OPTION,
];

// **************************
// SUSPENSION REASON
// **************************

export const getSuspensionReasonList = (language) => {
    switch (language) {
        case 'pt':
            return SUPPORT_SUSPENSION_REASONS;
        break;
        case 'en':
            return EN_SUPPORT_SUSPENSION_REASONS;
        break;
        case 'es':
            return ES_SUPPORT_SUSPENSION_REASONS;
        break;
        case 'fr':
            return FR_SUSPENSION_REASON_OTHER_OPTION;
        break;
        default:
            break;
    }
}

export const isReasonOther = (reason) => {
    if (reason === null) return false;

    return reason.code === SUSPENSION_REASON_OTHER_OPTION.code;
}

// PT Version

export const SUSPENSION_REASON_OTHER_OPTION = { name: 'Outro', code: 8 };

export const SUPPORT_SUSPENSION_REASONS = [
    { name: 'Desemprego', code: 1 },
    { name: 'Doença', code: 2 },
    { name: 'Gravidez', code: 3 },
    { name: 'Mudança de residência para outro país', code: 4 },
    { name: 'Não exercer, voluntariamente, a atividade profissional', code: 5 },
    { name: 'Situação de incompatibilidade com o exercício da profissão', code: 6 },
    { name: 'Suspensão por iniciativa própria', code: 7 },
    SUSPENSION_REASON_OTHER_OPTION
];

// EN Version

export const EN_SUSPENSION_REASON_OTHER_OPTION = { name: 'Other', code: 8 };

export const EN_SUPPORT_SUSPENSION_REASONS = [
    { name: 'Unemployement', code: 1 },
    { name: 'Illness', code: 2 },
    { name: 'Pregnancy', code: 3 },
    { name: 'Moving to another country', code: 4 },
    { name: 'Not voluntarily exercising professional activity', code: 5 },
    { name: 'Situation of incompatibility with the exercise of the profession', code: 6 },
    { name: 'Suspension on own initiative', code: 7 },
    EN_SUSPENSION_REASON_OTHER_OPTION
];

// ES Version

export const ES_SUSPENSION_REASON_OTHER_OPTION = { name: 'Otro', code: 8 };

export const ES_SUPPORT_SUSPENSION_REASONS = [
    { name: 'Desempleo', code: 1 },
    { name: 'Enfermedad', code: 2 },
    { name: 'Embarazo', code: 3 },
    { name: 'Cambio de residencia a otro país', code: 4 },
    { name: 'No ejercer la actividad profesional de forma voluntaria', code: 5 },
    { name: 'Situación de incompatibilidad con el ejercicio de la profesión', code: 6 },
    { name: 'Suspensión por iniciativa propia', code: 7 },
    ES_SUSPENSION_REASON_OTHER_OPTION
];

// FR Version

export const FR_SUSPENSION_REASON_OTHER_OPTION = { name: 'Autre', code: 8 };

export const FR_SUPPORT_SUSPENSION_REASONS = [
    { name: 'Chômage', code: 1 },
    { name: 'Maladie', code: 2 },
    { name: 'Grossesse', code: 3 },
    { name: 'Changement de résidence dans un autre pays', code: 4 },
    { name: "Ne pas exercer volontairement l'activité professionnelle", code: 5 },
    { name: "Situation d'incompatibilité avec l'exercice de la profession", code: 6 },
    { name: 'Suspension de sa propre initiative', code: 7 },
    FR_SUSPENSION_REASON_OTHER_OPTION
];
